import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from '@mui/material';

import { BorderedInputAdornment } from '~/modules/@shared/components';
import { roundNumber } from '~/modules/@shared/helpers/roundNumber';
import useGetSalesTax from '~/modules/payment/hooks/useGetSalesTax';
import { CreateInvoiceForm } from '../../helpers/createInvoiceSchema';

export default function InvoiceTotalField() {
  const { watch, setValue } = useFormContext<CreateInvoiceForm>();
  const { salesTax } = useGetSalesTax();
  const taxable = watch('taxable');
  const amount = watch('amount');

  useEffect(() => {
    const subTotal = Number(amount ?? 0);
    const taxFactor = taxable ? salesTax / 100 : 0;
    const tax = subTotal * taxFactor;
    const localTotal = subTotal + tax;
    const roundedTotal = roundNumber({ value: localTotal, decimals: 2 });

    setValue('total_amount', roundedTotal);
  }, [taxable, amount, salesTax, setValue]);

  return (
    <Controller
      name={'total_amount'}
      render={({ field }) => (
        <TextField
          {...field}
          value={field.value}
          disabled
          sx={{ border: '1px solid', borderRadius: 1, borderColor: 'divider' }}
          InputProps={{
            startAdornment: <BorderedInputAdornment position="start">$</BorderedInputAdornment>,
            inputProps: {
              min: 0,
            },
          }}
        />
      )}
    />
  );
}
